import { translate } from "@/modules/shared/IntlProviderWrapper";

export type SortDirection = 1 | -1 | "asc" | "desc";

export function sortDirectionIndicator<K extends string>(active_key: K, key: K, direction: SortDirection): string {
    if (active_key !== key) {
        return "";
    }
    const is_asc = direction === 1 || direction === "asc";
    return is_asc ? " \u25B2" : " \u25BC";
}

type SortableKpiThProps = {
    sort_key: string;
    label: string;
    numeric?: boolean;
    onClick: () => void;
    indicator: string;
};

export function SortableKpiTh(props: SortableKpiThProps) {
    return (
        <th key={props.sort_key} scope="col" className={props.numeric ? "text-right" : undefined}>
            <button type="button" className="btn btn-link p-0 text-decoration-none" onClick={props.onClick}>
                {props.label}
                {props.indicator}
            </button>
        </th>
    );
}

export function WinMixColumnHeader() {
    return (
        <th scope="col" className="text-center align-middle" title="Win mix">
            {translate("Manufacturing.ModelEvaluation.table.column.mix", "Mix")}
        </th>
    );
}
